/* eslint-disable @typescript-eslint/no-explicit-any */

import type { Object3D } from 'three'

export default function useAR() {
  const arMode = ref<(typeof ARMode)[keyof typeof ARMode]>(ARMode.NONE)

  async function selectARMode() {
    if (IS_SCENEVIEWER_CANDIDATE) {
      arMode.value = ARMode.SCENE_VIEWER
      return
    }

    const uaData = (navigator as any).userAgentData
    if (uaData?.getHighEntropyValues) {
      try {
        const values = await uaData.getHighEntropyValues(['formFactor'])
        if (values?.formFactor?.includes?.('XR')) {
          arMode.value = ARMode.SCENE_VIEWER
          return
        }
      } catch {
        // Some browsers throw on getHighEntropyValues — fall through.
      }
    }

    if (IS_AR_QUICKLOOK_CANDIDATE) {
      arMode.value = ARMode.QUICK_LOOK
    }
  }

  /**
   * Returns `true` if the AR app actually opened, `false` if the launch
   * silently fell back (e.g. no Scene Viewer handler on the device).
   */
  async function activateAR(model: Object3D): Promise<boolean> {
    switch (arMode.value) {
      case ARMode.QUICK_LOOK:
        return await openIOSARQuickLook(model)
      case ARMode.SCENE_VIEWER:
        return await openSceneViewerDynamic(model)
      default:
        console.warn(
          'No AR Mode can be activated. This is probably due to missing \
  configuration or device capabilities'
        )
        return false
    }
  }

  return {
    arMode,
    selectARMode,
    activateAR,
  }
}
